import { React, DomeComponent, DomeManipulator } from "@lexriver/dome";
import { EnumIconNames } from "../../enums/EnumIconNames";
import { LoadingSpinnerForButton } from "../LoadingSpinnerForButton";
import appCss from '../../App.m.scss'

interface Attrs{
    iconName?:EnumIconNames
    onClick:(e)=>void
    text:string
    style?:{[key:string]:string|number}
}

export class Button extends DomeComponent<Attrs>{
    ref?:HTMLButtonElement
    render(){
        if(this.attrs.iconName){
            return <button ref={(ref) => this.ref = ref} class={appCss.buttonLoadingAvailable} {...this.attrs.style?{style:this.attrs.style}:{}} onClick={this.attrs.onClick}><span class={this.attrs.iconName}/>{this.attrs.text}</button>
        }
        return <button ref={(ref) => this.ref = ref} class={appCss.buttonLoadingAvailable} {...this.attrs.style?{style:this.attrs.style}:{}} onClick={this.attrs.onClick}>{this.attrs.text}</button>
    }

    focus(){
        if(this.ref) this.ref.focus()
    }

    disable(){
        if(this.ref) this.ref.disabled = true
    }

    enable(){
        if(this.ref) this.ref.disabled = false
    }

    async switchToLoadingStateAsync(){
        if(!this.ref) return
        await DomeManipulator.removeAllChildrenAsync(this.ref)
        this.ref.appendChild(<LoadingSpinnerForButton />)
        this.ref.disabled = true

    }

    async switchOffLoadingStateAsync(){
        if(!this.ref) return
        this.ref.disabled = false
        await DomeManipulator.removeAllChildrenAsync(this.ref)
        await DomeManipulator.replaceAsync(this.ref, this.render())
        //this.buttonSubmit.textContent = this.getButtonText()
    }

}